export default __webpack_public_path__ + "42ea38d533f59a19f9e0d07fe6a6f29f.mp3";